/**
 * API Configuration
 * Uses environment-aware API base URL
 */

/// <reference types="vite/client" />

// Production API URL (includes /api path to match Worker routes)
const PRODUCTION_API = 'https://super-dashboard-api.jalen1wa.workers.dev/api';

// Detect environment - check if running on localhost
const isDev = typeof window !== 'undefined' &&
  (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1');

// API base URL - uses proxy in dev, direct URL in production
export const API_BASE = isDev ? '/api' : PRODUCTION_API;

// Full URLs for external sharing
export const getPublicMeetingUrl = (roomCode: string) => {
  const baseUrl = isDev
    ? `http://localhost:${window.location.port}`
    : 'https://super-dashboard-prod.pages.dev';
  return `${baseUrl}/meet/${roomCode}`;
};

export default {
  API_BASE,
  getPublicMeetingUrl,
};
